import { IntlShape } from 'react-intl';

import { getFormattedDate } from '@app/utils';
import {
  itemStatusPanelButtonMessages,
  sharedMessages,
} from '@app/translations';
import {
  ChargeDto,
  CheckoutDto,
  ItemStatus,
  ItemStatusData,
  statusIconMap,
} from '@app/constants';

import { getChargesData } from './getChargesData';

interface StatusesData {
  date: string;
  itemId: string;
  instanceId: string;
  isOverdue: boolean;
  intl: IntlShape;
  isVirtualItem?: boolean;
}

const getStatusesData = ({
  date,
  itemId,
  instanceId,
  isOverdue,
  intl,
  isVirtualItem,
}: StatusesData): ItemStatusData => {
  const status = isOverdue ? ItemStatus.overdue : ItemStatus.checkedOut;

  return {
    itemId,
    instanceId,
    icon: statusIconMap[status],
    status,
    statusMessage: getCheckoutsStatusMessage({ date, intl }),
    actionButtonText: intl.$t(itemStatusPanelButtonMessages.renew),
    isVirtualItem,
  };
};

export const getCheckoutsStatusMessage = ({
  date,
  intl,
}: {
  intl: IntlShape;
  date?: string;
}): string => intl.$t(sharedMessages.dueDate, { date });

export const getCheckoutsStatusesData = (
  checkouts: CheckoutDto[],
  charges: ChargeDto[],
  intl: IntlShape,
  locale: string
): ItemStatusData[] =>
  checkouts.map(
    ({ item: { instanceId, itemId, virtual }, overdue, dueDate }) => {
      const date = getFormattedDate({ date: dueDate, locale });
      const currentCharges = charges.find(
        charge => charge.item?.itemId === itemId
      );

      return Object.assign(
        getStatusesData({
          date,
          itemId,
          instanceId,
          isOverdue: overdue,
          intl,
          isVirtualItem: virtual,
        }),
        getChargesData({
          intl,
          chargeAmount: currentCharges?.chargeAmount,
        })
      );
    }
  );
